import React from "react";
import { timeline } from "../../data/site";
export function TimelineSection() {
  return <section className="bg-navy text-cream" aria-labelledby="timeline-title" data-id="element-153" data-mp="u0bxdd6qhx7f">
      <div className="mx-auto max-w-[1320px] px-5 py-24 md:px-10 md:py-28" data-id="element-154" data-mp="18oovafpdtq4k">
        <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end" data-id="element-155" data-mp="18qrjqvavzb76">
          <h2 id="timeline-title" className="max-w-xl font-serif text-4xl leading-[1.1] md:text-6xl" data-id="element-156" data-mp="13qdmm8atplnx">
            De 1978 à 2028, <span className="italic" data-id="element-157" data-mp="g1uebsrrx8vu">un demi-siècle d'envol.</span>
          </h2>
          <p className="max-w-sm text-cream/75" data-id="element-158" data-mp="b2r8i63yyymt">D'une expérience entre amis à un sport pratiqué dans le monde entier.</p>
        </div>

        <ol className="relative mt-16 grid gap-10 md:grid-cols-4 md:gap-8" data-id="element-159" data-mp="kz42z67c9gim">
          <span className="absolute left-0 right-0 top-[7px] hidden h-px bg-cream/25 md:block" aria-hidden="true" data-id="element-160" data-mp="l170sceqgdxw" />
          {timeline.map((step, i) => {
          const last = i === timeline.length - 1;
          return <li key={step.year} className="relative flex flex-col" data-id="element-161" data-mp="2z1yr19a2123m" data-mpi={i}>
                <span className={`relative h-[15px] w-[15px] rounded-full border-2 ${last ? "border-lime bg-lime" : "border-cream bg-navy"}`} aria-hidden="true" data-id="element-162" data-mp="2z42vptfs254y" />
                <p className={`mt-6 font-serif text-5xl ${last ? "text-lime" : "text-cream"}`} data-id="element-163" data-mp="3917j1wld06nc">{step.year}</p>
                <h3 className="mt-4 text-lg font-semibold" data-id="element-164" data-mp="3d0y91y32aiqt">{step.title}</h3>
                <p className="mt-2 leading-relaxed text-cream/75" data-id="element-165" data-mp="2gca3w2cg2pyt">{step.text}</p>
              </li>;
        })}
        </ol>
      </div>
    </section>;
}